import LanguageOutlined from '@mui/icons-material/LanguageOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import { IconPencilShare, IconSignature, IconTextRecognition } from 'components/icons';
// third-party
import { FormattedMessage } from 'react-intl';

// assets

import { NavItemType } from 'types';

const newOperation: NavItemType = {
    id: 'new-operation',
    title: <FormattedMessage id="NUEVA_OPERACION" />,
    icon: LanguageOutlined,
    type: 'group',
    children: [
        {
            id: 'esign-signdocument',
            title: 'FIRMAR_DOCUMENTO',
            type: 'item',
            url: '/esign-signdocument',
            icon: IconSignature
        },
        {
            id: 'esign-sendsign',
            title: 'ENVIAR_A_FIRMA',
            type: 'item',
            url: '/esign-sendsign',
            icon: IconPencilShare
        },
        /*         {
            id: 'otps-sendSign',
            title: 'OTPS',
            type: 'item',
            url: '',
            icon: IconDeviceMobile
        }, */
        {
            id: 'ocr',
            title: 'OCR_ID',
            type: 'item',
            url: '/ocr/send',
            icon: IconTextRecognition
        },
        /*         {
            id: 'voiceId-send',
            title: 'Voice ID',
            type: 'item',
            url: '',
            icon: IconMicrophone
        }, */
        {
            id: 'videoId',
            title: 'VIDEO_ID',
            type: 'item',
            url: '/videoId/send',
            icon: PersonOutlined
        }
    ]
};

export default newOperation;
